export default (theme) => ({
    container: {
        marginTop: '0px',
    },

    titulo: {
        fontWeight: '400',
        fontSize: '20px',
        lineHeight: '43px',
        color: '#02599E',
        marginBottom: '20px',
    },

    iconoClearEstado: {
        margin: '7px',
    },

    nroPresentacion: {
        '& .MuiOutlinedInput-root': {
            width: '195px',
        },
    },

    estado: {
        '& .MuiOutlinedInput-root': {
            width: '230px',
        },
    },

    nroRecepcion: {
        '& .MuiOutlinedInput-root': {
            width: '195px',
        },
    },

    nroPrestador: {
        '& .MuiOutlinedInput-root': {
            width: '195px',
        },
    },

    filaContainer: {
        marginTop: '20px',
        // marginButton: '2rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    btnLimpiar: {
        background: "none",
        width: '200px', 
        "&:focus": {
            outline: "none",
        },
        "&:hover": {
            background: 'none',
        },
        boxShadow: 'none !important',
            
    },

    
    dropDownIcon: {
        color: '#BDBDBD',
        margin: '5px',
    },
});
